export default (value, decimals) => {
    if (!decimals) decimals = 0;
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
};
